import { render, staticRenderFns } from "./distribute_briefing.vue?vue&type=template&id=6419769a&scoped=true"
import script from "./distribute_briefing.vue?vue&type=script&lang=js"
export * from "./distribute_briefing.vue?vue&type=script&lang=js"
import style0 from "./distribute_briefing.vue?vue&type=style&index=0&id=6419769a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419769a",
  null
  
)

export default component.exports